import React, { Component } from "react";
import axios from "axios";
// import {Link} from 'react-router-dom';
import domain from "./domain";
// import {BootstrapTable,TableHeaderColumn} from 'react-bootstrap-table'
import { CardBody, CardText, Card, CardTitle } from "mdbreact";
import moment from "moment-timezone";
import { Row, Col, Container } from "mdbreact";
// import EditProfileModal from './EditProfile'
import decode from "jwt-decode";
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employee_details: null,

      employee_all_details: null,
      username: null,
      admin_id: null,
    };
  }

  async fetchEmployeeProfile() {
    let res = await axios.get(
      `${domain.DBServer}/fetch-profile/${this.props.match.params.id}`
    );
    if (res.data) {
      //    console.log(res.data)
      this.setState({
        employee_details: [res.data[0]],

        employee_all_details: res.data,
      });
    } else {
      alert("Network Error");
    }
  }
  componentDidMount() {
    this.fetchEmployeeProfile();
    // localStorage.setItem("token", response.data.token)
    const { id, username } = decode(localStorage.getItem("token"));
    this.setState({
      username: username,
      admin_id: id,
    });
  }
  render() {
    let employee;
    let employee_activities;

    //  console.log(this.state.username)

    if (
      this.state.employee_details != null &&
      this.state.employee_all_details != null
    ) {
      employee = this.state.employee_details.map((employee, key) => {
        return (
          <div key={key}>
            <h3 style={{ color: "blue" }}>
              {employee.salutation + ". " + employee.empname}{" "}
            </h3>{" "}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {/* { (this.state.username==='wrgnhp')?<Link className="btn grey" to={`/admin-profile/${this.state.admin_id}`}>Back</Link>:<EditProfileModal emp_details={this.state.employee_details} employee_all_activities={this.state.employee_all_details} />} */}
            {/* <div> </div> */}
            <table
              className="table table-striped table-bordered table-responsive-md"
              cellSpacing="0"
              width="50%"
              key={key}
            >
              <tbody>
                <tr>
                  <td>Employee Code</td>
                  <td>{employee.employee_id}</td>
                  <td rowSpan="4" style={{ textAlign: "center" }}>
                    <img
                      alt=""
                      style={{ verticalAlign: "middle", dispaly: "inherit" }}
                      width="150"
                      height="150"
                      src={`${domain.DBServer}/${employee.photo}`}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Employee Name</td>
                  <td>{employee.empname}</td>
                </tr>
                <tr>
                  <td>Designation</td>
                  <td>{employee.designation}</td>
                </tr>
                <tr>
                  <td>Department</td>
                  <td>{employee.department}</td>
                </tr>
                <tr>
                  <td>Date of Joining</td>
                  <td>{moment(employee.doj).format("LL")}</td>
                </tr>
                <tr>
                  <td>Project Role</td>
                  <td>{employee.role_name}</td>
                </tr>

                <tr>
                  <td>E-mail</td>
                  <td>{employee.email}</td>
                </tr>
                <tr>
                  <td>Mobile Number</td>
                  <td>{employee.mobile}</td>
                </tr>
                <tr>
                  <td>Landline Number</td>
                  <td>{employee.landline}</td>
                </tr>
                {/* <tr>
                <td></td>
                     <td>{employee.email}</td>
                </tr>        
                         */}
              </tbody>
            </table>
          </div>
        );
      });
    }

    if (this.state.employee_all_details != null) {
      employee_activities = this.state.employee_all_details.map(
        (employee, key) => {
          return (
            <CardText key={key}>
              {key + 1}. {employee.activity_name}
            </CardText>
          );
        }
      );
    }

    return (
      <Container>
        <Row className="col-md-offset-5 col-centered">
          <Col md="12">
            <Card>
              <CardBody>
                {employee}
                <Card style={{ width: "22rem", marginTop: "1rem" }}>
                  <CardBody>
                    <CardTitle>Activities</CardTitle>

                    {employee_activities}
                  </CardBody>
                </Card>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
